import { AXES, UNI } from "./constants.js";
import type { Axes, Card, Experience, Uni } from "./types.js";

export function monthOk(months: string | null | undefined, m: number): boolean {
  if (!months || months === "全年") return true;
  return String(months)
    .split(",")
    .some((r) => {
      const [a, b] = r.split("-").map(Number) as [number, number | undefined];
      if (!b) return m === a;
      return a <= b ? m >= a && m <= b : m >= a || m <= b;
    });
}

export function computeAxes(likes: Card[], dislikes: Card[]): Axes {
  const out = {} as Axes;
  AXES.forEach(({ key }) => {
    let signed = 0,
      likeMass = 0,
      total = 0;
    likes.forEach((c) => {
      const v = c.ax[key];
      if (Math.abs(v) < 0.15) return;
      signed += v;
      likeMass += Math.abs(v);
      total += Math.abs(v);
    });
    dislikes.forEach((c) => {
      const v = c.ax[key];
      if (Math.abs(v) < 0.15) return;
      signed -= v;
      total += Math.abs(v);
    });
    const lean = total ? Math.max(-1, Math.min(1, signed / total)) : 0;
    const care = Math.min(1, (likeMass + Math.abs(signed)) / (total + 1.2));
    out[key] = { lean, care };
  });
  return out;
}
export function computeUni(likes: Card[], dislikes: Card[]): Uni {
  const s = { cul: 0, adv: 0, cra: 0, nig: 0, sho: 0 };
  likes.forEach((c) =>
    UNI.forEach(({ key }) => {
      s[key] += c.u[key];
    }),
  );
  dislikes.forEach((c) =>
    UNI.forEach(({ key }) => {
      s[key] -= 0.55 * c.u[key];
    }),
  );
  const max = Math.max(1, ...UNI.map(({ key }) => Math.abs(s[key])));
  const out = {} as Uni;
  UNI.forEach(({ key }) => {
    out[key] = Math.max(0, s[key]) / max;
  });
  return out;
}

export function pickNext(
  pool: Card[],
  seen: Set<string>,
  exposure: Record<string, number>,
  rng: () => number = Math.random,
): Card | null {
  const cands = pool.filter((c) => !seen.has(c.id));
  if (!cands.length) return null;
  const scored = cands.map((c) => {
    let s = 0;
    AXES.forEach(({ key }) => {
      const v = c.ax[key];
      const pole = key + (v > 0 ? "+" : "-");
      s += Math.abs(v) * (1 / (1 + (exposure[pole] || 0)));
    });
    UNI.forEach(({ key }) => {
      s += c.u[key] * (1 / (1 + (exposure[key] || 0)));
    });
    return { c, s: s + rng() * 0.3 };
  });
  scored.sort((a, b) => b.s - a.s);
  return scored[0]!.c;
}

export function expScore(c: Experience, uni: Uni, axes: Axes): number {
  let s = 0;
  UNI.forEach(({ key }) => {
    s += uni[key] * c.u[key];
  });
  AXES.forEach(({ key }) => {
    const { lean, care } = axes[key];
    s += care * (1 - Math.abs(c.ax[key] - lean) / 2);
  });
  return s;
}
